import { render, staticRenderFns } from "./courseTaskeight.vue?vue&type=template&id=1d2f4844&scoped=true"
import script from "./courseTaskeight.vue?vue&type=script&lang=js"
export * from "./courseTaskeight.vue?vue&type=script&lang=js"
import style0 from "./courseTaskeight.vue?vue&type=style&index=0&id=1d2f4844&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2f4844",
  null
  
)

export default component.exports